import { FilterOptions } from "./interfaceHelper";
import moment from "moment-timezone";

//Sets the filters that should be used: defaults the filters to a status filter for open/identified tickets
function isValidFilterOption(
  prop: string,
  filters: FilterOptions
): prop is keyof FilterOptions {
  return prop in filters;
}

const USER_TIMEZONE =
  Intl.DateTimeFormat().resolvedOptions().timeZone ?? "Europe/London";

const DATE_FORMAT = "HH:mm, DD/MM/YYYY";
const TIME_ZONE_DISPLAY = `Time zone ${USER_TIMEZONE}`;

const dateDisplay = (date: string) =>
  date ? moment.utc(date).tz(USER_TIMEZONE).format(DATE_FORMAT) : "";
const personDisplay = (person: string) => (person === "Null" ? "N/A" : person);
const companyDisplay = (company: string | null) => company || "Unknown";
const agentDisplay = (agent: string) => (agent === "" ? "No Agent" : agent);
const ticketTypeDisplay = (ticketType: string) =>
  ticketType === "Incident" ? "INC" : "SR";

export {
  isValidFilterOption,
  dateDisplay,
  personDisplay,
  companyDisplay,
  agentDisplay,
  ticketTypeDisplay,
  DATE_FORMAT,
  TIME_ZONE_DISPLAY,
  USER_TIMEZONE,
};
